import { createSlice } from "@reduxjs/toolkit";

// open: 최상단(Navbar) 워크플로우 버튼이 토글하는 우측 패널 열림 상태 (AgentChatState.open과 동일 패턴).
//   focusId: 열면서 펼칠 워크플로우 id(홈 '내 할 일' 클릭 등). 패널이 소비해 해당 목록을 펼친다.
const workflowPanelState = createSlice({
  name: "workflowPanelState",
  initialState: { open: false, focusId: null },
  reducers: {
    toggleWorkflowPanel: (state) => { state.open = !state.open; },
    setWorkflowPanelOpen: (state, action) => { state.open = action.payload; },
    // 특정 워크플로우를 펼친 채로 패널 열기
    openWorkflowPanel: (state, action) => { state.open = true; state.focusId = action.payload ?? null; },
  },
});

export const { toggleWorkflowPanel, setWorkflowPanelOpen, openWorkflowPanel } = workflowPanelState.actions;
export const getWorkflowPanelOpen = (state) => state.workflowPanelState.open;
export const getWorkflowPanelFocusId = (state) => state.workflowPanelState.focusId;
export default workflowPanelState.reducer;
